import React, { useEffect, useState } from "react";
import { api } from "@/lib/apiClient";
import { useAuth } from "@/context/AuthContext";

export default function AvaSso() {
  const { checkAuth } = useAuth();
  const [state, setState] = useState("verifying");

  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get("ava_sso_token");
    if (!token) {
      window.location.replace("/login?sso=missing");
      return;
    }
    api
      .post("/ava-sso/verify", { token })
      .then(async () => {
        await checkAuth();
        window.location.replace("/");
      })
      .catch(() => {
        setState("denied");
        setTimeout(() => window.location.replace("/login?sso=denied"), 1600);
      });
  }, [checkAuth]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-5 bg-[#050505] text-white" data-testid="ava-sso-page">
      <div className="h-14 w-14 rounded-full border-2 border-cyan-400/30 border-t-cyan-400 animate-spin" />
      <p className="font-mono text-sm txt-cyan" data-testid="ava-sso-status">
        {state === "denied" ? "AVA sign-in rejected — returning…" : "Signing in with AVA mothership…"}
      </p>
    </div>
  );
}
